"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISubscriptionType = void 0;
var ISubscriptionType;
(function (ISubscriptionType) {
    ISubscriptionType[ISubscriptionType["Waitlist"] = 0] = "Waitlist";
    ISubscriptionType[ISubscriptionType["Carbon"] = 1] = "Carbon";
    ISubscriptionType[ISubscriptionType["Airdrop2"] = 2] = "Airdrop2";
    ISubscriptionType[ISubscriptionType["PioneeringTech"] = 3] = "PioneeringTech";
    ISubscriptionType[ISubscriptionType["AirdropChess"] = 4] = "AirdropChess";
    ISubscriptionType[ISubscriptionType["Veax"] = 5] = "Veax";
    ISubscriptionType[ISubscriptionType["StakeSuise"] = 6] = "StakeSuise";
    ISubscriptionType[ISubscriptionType["Concorstarter"] = 7] = "Concorstarter";
    ISubscriptionType[ISubscriptionType["Concordex"] = 8] = "Concordex";
    ISubscriptionType[ISubscriptionType["Giveaway"] = 9] = "Giveaway";
})(ISubscriptionType = exports.ISubscriptionType || (exports.ISubscriptionType = {}));
